module.exports = __webpack_public_path__ + "img/51626526_L.90883b80.png";